"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setInterceptor = exports.setOnError = exports.setStoreAuthTokenFunction = exports.setCognitoUserSession = exports.setCognitoUser = exports.setAPIUrl = exports.setSharedAuthToken = exports.axiosUnauthenticated = exports.axios = void 0;
const axios_1 = __importDefault(require("axios"));
let apiUrl;
let cognitoUser = null;
let cognitoUserSession = null;
let storeAuthToken;
let onError;
exports.axios = axios_1.default.create({
    baseURL: apiUrl,
});
exports.axiosUnauthenticated = axios_1.default.create({
    baseURL: apiUrl,
});
function setSharedAuthToken(authToken) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    exports.axios.defaults.headers.common['Authorization'] = authToken;
}
exports.setSharedAuthToken = setSharedAuthToken;
function setAPIUrl(url) {
    apiUrl = url;
    // axios.defaults.baseURL = url
    exports.axios = axios_1.default.create({
        baseURL: apiUrl,
    });
}
exports.setAPIUrl = setAPIUrl;
function setCognitoUser(user) {
    cognitoUser = user;
}
exports.setCognitoUser = setCognitoUser;
function setCognitoUserSession(session) {
    cognitoUserSession = session;
}
exports.setCognitoUserSession = setCognitoUserSession;
function setStoreAuthTokenFunction(func) {
    storeAuthToken = func;
}
exports.setStoreAuthTokenFunction = setStoreAuthTokenFunction;
function setOnError(func) {
    onError = func;
}
exports.setOnError = setOnError;
function setInterceptor() {
    exports.axios.interceptors.request.use((config) => {
        if (!cognitoUser)
            return new Promise((resolve) => resolve(config));
        return new Promise((resolve, reject) => {
            if (!cognitoUserSession || !cognitoUser) {
                onError(new Error('User session or user does not exist'));
                return resolve(config);
            }
            const accessTokenExpire = cognitoUserSession.getAccessToken().getExpiration();
            const currentTimeSeconds = Math.round(+new Date() / 1000);
            if (accessTokenExpire > currentTimeSeconds) {
                return resolve(config);
            }
            getCognitoUserSession()
                .then((session) => {
                if (!session)
                    return reject();
                setCognitoUserSession(session);
                const authToken = session.getAccessToken().getJwtToken();
                storeAuthToken(authToken);
                config.headers.common.Authorization = `bearer ${authToken}`;
                resolve(config);
            })
                .catch(() => {
                onError(new Error('Unable to retrieve new user session'));
                resolve(config);
            });
        });
    });
}
exports.setInterceptor = setInterceptor;
const getCognitoUserSession = () => new Promise((resolve, reject) => {
    if (!cognitoUser)
        return resolve(null);
    cognitoUser.getSession((err, session) => {
        if (err) {
            return reject(err.message);
        }
        resolve(session);
    });
});
//# sourceMappingURL=Axios.js.map